import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { LINK_POWER_DIALER } from 'shared/constants/links'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { PowerDialerEditorStore } from 'widgets/PowerDialer/ui/PowerDialerEditor/store/powerDialerEditorStore'
import { usePowerDialerAvailability } from 'widgets/PowerDialer/ui/PowerDialerEditor/hooks/usePowerDialerAvailability'
import { useCallPopUpGlobalContext } from 'widgets/CallPopUp/context/callPopUpGlobalContext'
import styles from './styles.module.scss'

export const PowerDialerNewSessionAction = observer(() => {
  const callPopUpGlobalStore = useCallPopUpGlobalContext()
  const entities = useEntitiesContext()
  const { eventLogStore, organizationStore } = entities
  const { hideButton, disabled, getTooltipAvailability } = usePowerDialerAvailability()
  const availabilityLabel = getTooltipAvailability()

  if (hideButton) return null

  return (
    <Button
      text='New campaign'
      iconProps={{ icon: 'add' }}
      size='medium'
      disabled={disabled}
      onClick={() => {
        eventLogStore.logEvent(
          'Power Dialer Used',
          {
            event_id: 'power_dialer_used',
            action: 'clicked in PD campaigns',
          },
          { groupId: organizationStore.id }
        )
        new PowerDialerEditorStore(
          callPopUpGlobalStore,
          entities
        ).handleStartPowerDialerEditorFromFilters('pdCampaigns')
      }}
      tooltipProps={{
        label: availabilityLabel,
        placement: 'top',
      }}
    />
  )
})

export const PowerDialerHelpGuideAction = observer(() => {
  return (
    <Button
      tag='a'
      text='Help guide'
      size='medium'
      contained='secondary'
      iconProps={{ icon: 'info' }}
      className={styles.helpButton}
      href={LINK_POWER_DIALER}
      target='_blank'
      rel='noreferrer'
    />
  )
})
